import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// @ts-ignore
import { submittingSelectors } from 'shared';
import { AppState } from 'services/types';

// Components
import ExitConfirmation from 'components/ExitConfirmation';

interface OwnProps {}

interface ConnectedProps {
    isSubmitting: boolean;
}

type Props = OwnProps & ConnectedProps;

export class ExitSubmitting extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { isSubmitting } = this.props;

        return (
            <ExitConfirmation
                onlyPathname
                message="Are you sure you want to leave? Changes that you made may not be saved"
                when={isSubmitting}
            />
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    isSubmitting: submittingSelectors.selectIsSubmitting()
});

export default connect(mapStateToProps)(ExitSubmitting);
